import { GraphQLClient } from "../../../../shared/gql-client";
import {
  BulkRelationResponseModel,
  BulkRequestResponseModel,
  BulkTireSetResponseModel,
} from "../../domain/models/bulkModels";
import { gql } from "@apollo/client";

export default class BulkService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  private buildQuery(
    model: string,
    ids: string[],
    fields: Array<{ field: string; value: string }>,
    bulkFieldsResponseExclude?: string[],
  ): string {
    const fieldsString = fields
      .map((field) => {
        const needsQuotes =
          field.field !== "status" &&
          field.field !== "in_hotel" &&
          field.field !== "sleep_set";
        return `${field.field}: ${needsQuotes ? `"${field.value}"` : field.value}`;
      })
      .join(", ");

    let responseFieldsArr = fields
      .map((field) => field.field)
      .filter((field) => !bulkFieldsResponseExclude?.includes(field));
    if (responseFieldsArr.length === 0) {
      responseFieldsArr = ["id"];
    }
    const responseFields = responseFieldsArr.join(", ");

    return `mutation Update${model}Bulk {
            update${model}Bulk(ids: [${ids.join(", ")}], ${fieldsString}) {
                ${responseFields}
            }
        }`;
  }

  mutate(
    model: string,
    ids: string[],
    fields: Array<{ field: string; value: string }>,
    bulkFieldsResponseExclude?: string[],
  ): Promise<
    | BulkRequestResponseModel
    | BulkRelationResponseModel
    | BulkTireSetResponseModel
  > {
    return new Promise((resolve, reject) => {
      const query = this.buildQuery(
        model,
        ids,
        fields,
        bulkFieldsResponseExclude,
      );
      this.client
        ?.mutate("updateBulk", gql(query))
        .then((response) => {
          const data = response as
            | BulkRequestResponseModel
            | BulkRelationResponseModel
            | BulkTireSetResponseModel;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
